<template>
  <Container type="card-full">
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
          :showfooter="false" :showPage="false" :resizable="true"
           @cellClick="cellClick" @cellDblClick="cellDblClick"
          :isOperate="btn.isOperate"
          :operateBtn="btn.right" @vggridClick="vggridClick"
          :sortConfig="{defaultSort:{field:'qcmseq',order:'asc'},showIcon:true,iconAsc:'el-icon-arrow-up'}"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
    <!-- <vxe-table
          border
          resizable
          height="300"
          :scroll-y="{gt: -1}"
          :span-method="mergeRowMethod"
          :data="list">
            <vxe-table-column type="index" width="60"></vxe-table-column>
            <vxe-table-column field="qcmchecktypeCN" title="初审类型"></vxe-table-column>
            <vxe-table-column field="qcmcheckcontent" title="初审内容"></vxe-table-column>
            <vxe-table-column field="qcmcheckdemand" title="初审要求"></vxe-table-column>
    </vxe-table> -->
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  import XEUtils from 'xe-utils'
  export default {
    name: 'qcmReview',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        loading:false,
        btn:{},
        cols: [
          { field: 'ind',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          // { title: '初审类型 ', width: 160, showOverflow: true,
          //   slots: {
          //     default: 'default',
          //     default: ({row}) => {
          //         let name = ''
          //         this.qcmchecktypeList.forEach(e => {
          //             if( +e.syscodeseq === +row.qcmchecktype ){
          //               name = e.syscodename
          //             }
          //         });
          //         return name
          //     }}
          // },
          { field: 'qcmchecktypeCN', fieldtype: 'C', title: '初审类型',calculExpr:'',addNewRowFlg: false},
          { field: 'qcmcheckcontent', fieldtype: 'C', title: '初审内容',calculExpr:'',addNewRowFlg: false},
          // { field: 'qcmcheckdemand', fieldtype: 'F', title: '初审要求',calculExpr:'',addNewRowFlg: false},
          { field: 'qcmseq', fieldtype: 'I', title: '顺序',calculExpr:'',addNewRowFlg: false, width: 80}
        ],
        qcm: {},
        qcmchecktypeList:[],
      }
    },
    created () {
      this.$on('ADD', () => this.addQR())
      this.$on('CHG', () => this.chgQR())
      this.$on('DEL', () => this.delQR())
    },
    activated() {
      this.getQRList()
      this.getqcmtypeList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.qcm = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async cellClick (row) {
        this.qcm = row.row
      },
      async cellDblClick(row){

      },
      async getQRList(){
        this.loading = true
        let from = {}
        from.qcmcosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/ywgl/qcm/getQRList',
          params: from
        })
        this.list = res
        this.list.forEach(e => {
           e.qcmchecktypeCN = e.qcmchecktype === 1 ? '资格性':'审查性'
           e.ind = e.qcmchecktype === 1 ? '1':'2'
        })
        this.list.sort((a,b)=>{
          return a.qcmchecktype - b.qcmchecktype
        });
        this.loading = false
      },
      addQR(){
        let form = {
          qcmid: 0,
          qcmcosid:this.$store.getters.loginUser.cosid,
        }
        this.$router.push({name: 'qcmFrom', params: {form: form, type: 1}})
      },
      chgQR(){
        this.$router.push({name: 'qcmFrom', params: {form: this.qcm, type: 1}})
      },
      async getqcmtypeList(){
        this.qcmchecktypeList = await request({
            url: '/kfgl/syscode/getSysCodeList',
            method: "get",
            params: {syscode: 'qcmchecktype'}
        })
      },
      async delQR () {
          this.$confirm('确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let data = await request({
              url: '/ywgl/qcm/delqcm',
              method: "post",
              data: this.qcm
          })
          if (data.issuccess===1) {
            this.getQRList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // mergeRowMethod ({ row, $rowIndex, column, data }) {
      //   let fields = ['qcmchecktypeCN']
      //   let cellValue = XEUtils.get(row, column.property)
      //   if (cellValue && fields.includes(column.property)) {
      //     let prevRow = data[$rowIndex - 1]
      //     let nextRow = data[$rowIndex + 1]
      //     if (prevRow && XEUtils.get(prevRow, column.property) === cellValue) {
      //       return { rowspan: 0, colspan: 0 }
      //     } else {
      //       let countRowspan = 1
      //       while (nextRow && XEUtils.get(nextRow, column.property) === cellValue) {
      //         nextRow = data[++countRowspan + $rowIndex]
      //       }
      //       if (countRowspan > 1) {
      //         return { rowspan: countRowspan, colspan: 1 }
      //       }
      //     }
      //   }
    // }
    },
    filters: {
    },
    computed: {
    }
  }
</script>
<style lang="scss">

</style>
